<template>
  <v-layout row>
    <v-flex>
      <div>
        <v-toolbar text dark>
          <v-dialog v-model="dialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="editedItem.deliverydate"
                        label="Date"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="editedItem.notes"
                        :items="notes2"
                        prepend-icon="whatshot"
                        label="Select Notes2"
                        chips
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="editedItem.notes2"
                        label="Notes"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="editedItem.location"
                        label="Location"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="editedItem.qty"
                        label="Qty"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="editedItem.product"
                        :items="items"
                        :rules="[v => !!v || 'Product type is required']"
                        prepend-icon="whatshot"
                        label="Select products"
                        required
                        chips
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="editedItem.finish"
                        :items="items2"
                        prepend-icon="whatshot"
                        label="Select Finish"
                        chips
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="editedItem.postcode"
                        label="Postcode"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-toolbar-title>Status</v-toolbar-title>
          <v-divider class="mx-2" inset vertical></v-divider>
          <span>{{ new Date() | moment("dddd, MMMM Do YYYY") }}
           </span>
          <v-divider class="mx-2" inset vertical></v-divider>
          <v-dialog v-model="toFactory" persistent max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn text class="primary pa-1" dark v-on="on"
                >Credit Check</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline"
                  >Credit Check - {{ selected.length }} items selected
                </span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout row>
                    <v-layout column>
                      <h2>Work # || Total</h2>
                      <v-flex xs1 v-for="i in filterSelected" :key="i.worknum">
                        <h2>{{ i.customer }} - £{{ i.tTotal }}</h2>
                      </v-flex>
                      <v-flex xs4>
                        <h2>Grand Total : £{{ totalsum }}</h2>
                      </v-flex>
                    </v-layout>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="toFactory = false"
                  >Close</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-spacer></v-spacer>

          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
          ></v-text-field>
        </v-toolbar>
      <!-- Main CRUD data table -->
      <v-data-table dense :headers="headers" :items="orders" sort-by="name" :search="search" v-model="selected" item-key="worknum" show-select>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            edit
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <!-- End of CRUD table -->
    </v-card>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
  import moment from 'moment'
  import firebase from 'firebase'
  import db from '@/fb'
  export default {
    
    data: () => ({
      dialog: false,
      toFactory: false,
      selected: [],
        notes2: [
          'Glass In',
          'Veneer In',
          'Special In',
          'Formica In',
        ],
        items2: [
          ' - ',
        'Primed',
        'Lacquered',
        'Laminate',
        'Sealant',
        'Other/Special',
        'Sealed'
      ],
         items: [
        'Doors',
        'Frame',
        'Timber Section',
        'Screens',
        'Glass',
        'Iron Mongory'
      ],
      test: '',
      filterArr: [],
      isActive: true,
      search: '',
      worknum:'',
      customer:'',
      contract:'',
      product:'',
      select: '',
      finish: ' ',
      fsc:'',
      date:'',
      headers: [
        { text: 'W/C:', align: 'left', value: 'deliverydate'},
        {text: 'Work #', align: 'left', value: 'worknum',sortable: false},
        { text: 'Customer', align: 'left', value: 'customer',sortable: false  },
        { text: 'Product', align: 'left', value: 'product',sortable: false  },
        { text: 'Status', align: 'left', value: 'status',sortable: false  },
        { text: 'Progress', align: 'left', value: 'progress'},
            
      ],
      orders: [],
      users: [],
      editedIndex: -1,
      editedItem: {
        worknum:'',
        customer:'',
        location:' ',
        quantity:'',
        product: ' ',
        finish:'',
        inFactory: false,
        mill: false,
        mach: false,
        bench: false,
        spray: false,
        notes:'',
        notes2: '',
        deliverydate:'',
        postcode:' ',
        finish: ' ',
      },
      defaultItem: {
        worknum:'',
        customer:'',
        location:'',
        quantity:'',
        product: ' ',
        finish:'',
        inFactory: false,
        mill: false,
        mach: false,
        bench: false,
        spray: false,
        notes:'',
        postcode:' ',
        finish: ' ',
      },
      newarr:[],
      accounts:[],
      totalsum:0,
    }),
    computed: {

      filterSelected(){
        var tempArr = []
        var obj = {}
        var sum = 0
        for(var x=0;x<this.selected.length; x++){
          for(var y=0; y<this.accounts.length; y++){
            if(this.selected[x].worknum == this.accounts[y].worknum){
              obj={
                worknum: this.accounts[y].worknum,
                customer: this.accounts[y].customer,
                vdoor: this.accounts[y].vdoor,
                vframe: this.accounts[y].vframe,
                vother: this.accounts[y].vother,
                total: Number(this.accounts[y].vdoor) + Number(this.accounts[y].vframe) + Number(this.accounts[y].vother)
              }
              tempArr.push(obj)
              sum = sum + Number(this.accounts[y].vdoor + Number(this.accounts[y].vframe) + Number(this.accounts[y].vother))

            }
          }
        }
        var result = tempArr.reduce(function(acc, curr) {
                //Map customers together and total up values
            if (curr.customer) {
                var fromMap = acc.map[curr.customer];
                if (!fromMap) {
                acc.map[curr.customer] = fromMap = {
                    customer: curr.customer,
                    vdoor: curr.vdoor,
                    vframe: curr.vframe,
                    vother: curr.vother,
                    tdoor:0,
                    tframe:0,
                    tother:0,
                    tTotal:0,
                }
                acc.result.push(fromMap);
                }
                fromMap.tdoor += Number(curr.vdoor);
                fromMap.tframe += Number(curr.vframe);
                fromMap.tother += Number(curr.vother);
                fromMap.tTotal = fromMap.tdoor + fromMap.tframe + fromMap.tother
            } else {
                acc.result.push(curr);
            }
            return acc;
            }, {
            map: {},
            result: []
            }).result;
            return result
        
        
      },

      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },

    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    created () {
       db.collection("orders")
        .orderBy("date", "asc")
        .get()
        .then(querySnapshot => {
          const cache = [];
          querySnapshot.forEach(doc => {
            cache[doc.id] = doc.data();
            cache[doc.id].id = doc.id

              this.orders.push(cache[doc.id]);
            
          });
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });

         db.collection("accounts")
        .orderBy("date", "asc")
        .get()
        .then(querySnapshot => {
          const cache = [];
          querySnapshot.forEach(doc => {
            cache[doc.id] = doc.data();
            cache[doc.id].id = doc.id

              this.accounts.push(cache[doc.id]);
            
          });
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });

     /* db.collection('accounts').onSnapshot(res =>{
        const changes = res.docChanges();
        changes.forEach(change =>{
          if(change.type === 'added'){
            this.accounts.push({
              ...change.doc.data(),
              id: change.doc.id
            })            
          }
        })
      }),
     
      db.collection('orders').onSnapshot(res =>{
        const changes = res.docChanges();
        changes.forEach(change =>{
          if(change.type === 'added'){
            this.orders.push({
              ...change.doc.data(),
              id: change.doc.id
            })
  
          }
        })
      }) */

    },
    
    methods: {
      toggleAll () {
        if (this.selected.length) this.selected = []
        else this.selected = this.newarr.slice()
      },
        
       
      withDateStyle: function(val) {
                    //rd is rental duration
                  var  rd = moment(val.deliverydate).week()
                    //console.log(rd)
                    var lengthColor
                    var otherCriterionColor
                    if (rd === moment(new Date()).week()) {
                        lengthColor = 'black'
                        otherCriterionColor = 'yellow'
                    } else if (rd > moment(new Date()).week()) {
                        lengthColor = 'black'
                        otherCriterionColor = 'white'
                    } else if (rd < moment(new Date()).week()){
                        lengthColor = 'white'
                        otherCriterionColor = 'grey'
                    }
                    if(val.status === 'ON HOLD'){
                        lengthColor = 'black'
                        otherCriterionColor = 'red'
                    }
                    if(val.status === 'Delivered'){
                        lengthColor = 'red'
                        otherCriterionColor = 'black'
                    }
                    return { color: lengthColor, background: otherCriterionColor}
        },
      
      editItem (item) {
        this.editedIndex = this.orders.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        const index = this.orders.indexOf(item)
        const countTruthy = (a, b) => {
              return b ? a + 1 : a;
        }
        //UPDATE USERS WITH COMPLETION Check if all boxes are ticked firstly
        console.log(item.steps)
       var count  = Object.values(item.steps).reduce(countTruthy,0)
       console.log(count +"True Values")
        if (count == Object.values(item.steps).length){
           console.log("All True")
           confirm('Are you sure you want to complete this item?')
           item.status = 'Delivered'
           db.collection('orders').doc(item.id).update({
                    status: 'Delivered',
                }).then(()=>{
                    this.$emit('Delivered')
                })
           db.collection('history').add(item).then(()=>{
                        console.log('ADDED to db')
                        this.$emit('orderCreated')
        })
        }else{
          console.log("not all true")
          alert("Order not complete")
        }
        
      },
       save () {
        //console.log(this.editedItem.id)
        if (this.editedIndex > -1) {
          Object.assign(this.orders[this.editedIndex], this.editedItem)
          
           
        } else {
          this.orders.push(this.editedItem)
          
        }
        
        this.close()
        db.collection('orders').doc(this.orders[this.editedIndex].id).update({
              
              deliverydate:this.editedItem.deliverydate,
              notes: this.editedItem.notes,
              notes2: this.editedItem.notes2,
              qty: this.editedItem.qty,
              postcode: this.editedItem.postcode,
              location: this.editedItem.location,
              product: this.editedItem.product,
              finish: this.editedItem.finish,
          }).then(()=>{
              this.$emit('Delivered')
          })
      },


      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      submit(){
            if(this.$refs.form.validate()){
                this.loading = true;
                const order ={
                    worknum: this.orders.length,
                    customer: this.customer,
                    contract: this.contract,
                    ordernum: this.ordernum,
                    product: this.product,
                    fsc: this.allowSpaces,
                    date: this.date  
                                      
                }
                this.orders.push(order)
                
                                 
           }
           this.$refs.form.reset()
           this.loading = false; 
        }
    }
  }
</script>
<style >
table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
  padding: 0 5px;
  
  
}
.mytable table th {
    background-color: rgb(67, 106, 232);
    color: black;
}
.mytable table tr {
    background-color: rgba(122, 206, 28, 0.638);
   
}


</style>